<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='success' icon='wms wms-qrcode' class='navbarbtn' v-if='showCreateQRCodePower'
        @click='showCreateQRCodeDialogMD'>
        生成条码
      </el-button>

      <el-button type='success' icon='wms wms-qrcode' class='navbarbtn' v-if='showCreateOneItemQRCodePower'
        @click='showCreateOneItemQRCodeDialogMD'>
        生成条码（单物料）
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.qrCode' style='width: 125px;' placeholder='标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.outerQRCode' style='width: 125px;' placeholder='外箱标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='false'
      :reduceHeight='200' :seqFixed='true'
      :expandRowKeys='mainTable.expandRowKeys'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>状态</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>生产日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(qrCode, qrCodeIndex) in scope.data.row.detailDt1'
            :key='qrCode.QRCode' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{qrCode.BU_Name}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: #42426F;'>{{showQRCodesTransformSpecialString('Status', qrCode.Status)}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.OuterQRCode}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFDate}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFPeriod}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='生成标签' :visible.sync='showCreateQRCodeDialog' fullscreen>
      <el-table :data='qrcodeRows' border :height='getCreateQRCodeHeight()' ref='createQRCodeTable'
        :cell-style='{ padding: "0px" }' :header-cell-style='createQRCodeHeaderCellStyle' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='BillNo' label='生产任务单号' width='180'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='250'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='250'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='计划生产数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateQRCodeQty' label='已经生成标签数量' width='80'>
        </el-table-column>
        <el-table-column prop='ThisCreateQty' label='本次生成标签数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateQty' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitPackageNumber' label='每包数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitPackageNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitBoxNumber' label='每箱最大包数' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitBoxNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='160'>
          <template #default='scope'>
            <el-date-picker style='width: 140px;' size='mini'
              v-model='scope.row.KFDate' value-format='yyyy-MM-dd'
              @input='createQRCodeTableKFDateChange(scope.row)'></el-date-picker>
          </template>
        </el-table-column>
        <!-- <el-table-column prop='ProducetItemID' label='专用产品号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ProducetItemID' style='width: 80px;'/>
          </template>
        </el-table-column> -->
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='120'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.BatchNo' style='width: 100px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='BZ' label='班组' width='160'>
          <template #default='scope'>
            <el-select v-model='scope.row.BZ' placeholder='请选择'
              class='inputField-input' @change='createQRCodeTableKFDateChange(scope.row)'
              style='width: 140px;' size='mini'>
              <el-option v-for='bz in bzs'
                :key='bz.code' :label='bz.name + "(" + bz.code + ")"' :value='bz.code'>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='200'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button class='inputField-input' type='primary' @click='autoCompleteCreateQRCodeQty()'
          size='mini'>自动填充生成数量</el-button>
        <el-button class='inputField-input' type='primary' @click='clearCreateQRCodeQty()'
          size='mini'>清除生成数量</el-button>
        <el-button type='primary' @click='createQRCode()' size='mini'>生成并打印</el-button>
        <el-button @click='showCreateQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='生成标签（单物料）' :visible.sync='showCreateOneItemQRCodeDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          每箱最大包数
        </div>
        <el-input size='mini' class='inputField-input' v-model='UnitBoxNumber' style='width: 100px;'
          placeholder='请输入'></el-input>
        <div class='inputField-label' style='width: 120px; text-align: left'>
          本次标签合计数量
        </div>
        <el-input size='mini' class='inputField-input' v-model='sumQty' style='width: 100px;' disabled
          placeholder='请输入'></el-input>
      </div>
      <el-table :data='itemQRCodeRows' border :height='getCreateOneItemQRCodeHeight()' ref='createOneItemQRCodeTable'
        :cell-style='{ padding: "0px" }' :header-cell-style='createOneItemQRCodeHeaderCellStyle'
        style='margin-top: 40px;' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='280'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='280'>
        </el-table-column>
        <el-table-column prop='Qty' label='计划生产数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateQRCodeQty' label='已经生成标签数量' width='80'>
        </el-table-column>
        <el-table-column prop='ThisCreateQty' label='本次生成标签数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateQty' style='width: 60px;' @blur='sumQtyComputer'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitPackageNumber' label='每包数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitPackageNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='160'>
          <template #default='scope'>
            <el-date-picker style='width: 140px;' size='mini'
              v-model='scope.row.KFDate' value-format='yyyy-MM-dd'
              @input='createOneItemQRCodeTableKFDateChange(scope.row)'></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.BatchNo' style='width: 80px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='BZ' label='班组' width='160'>
          <template #default='scope'>
            <el-select v-model='scope.row.BZ' placeholder='请选择'
              class='inputField-input' @change='createOneItemQRCodeTableKFDateChange(scope.row)'
              style='width: 140px;' size='mini'>
              <el-option v-for='bz in bzs'
                :key='bz.code' :label='bz.name + "(" + bz.code + ")"' :value='bz.code'>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop='ProducetItemID' label='专用产品号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ProducetItemID'
              @input='createOneItemQRCodeTableProducetItemIDChange(scope.row)' style='width: 80px;'/>
          </template>
        </el-table-column> -->
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='200'>
        </el-table-column>
        <el-table-column label='操作' width='50' fixed='right'>
          <template #default='scope'>
            <el-tooltip effect='dark' content='删除' placement='top-start'>
              <el-button type='danger' circle style='padding: 4px;'
                @click='deleteOneItemQRCodeRow(scope.row, scope.$index)'><i class='sys sys-delete'></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='addOneItemQRCodeRow()' size='mini'>添加行</el-button>
        <el-button type='primary' @click='createOneItemQRCode()' size='mini'>生成并打印</el-button>
        <el-button @click='showCreateOneItemQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import dateTimeUtil from '@/utils/dateTimeUtil'
import axiosHelper from '@/utils/axiosHelper'
import { Loading } from 'element-ui'

export default {
  name: 'CreateICMOQRCode',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PM_ICMO_2',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        qrCode: '',
        outerQRCode: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      bzs: [],
      qrcodeStatuss: [],
      showCreateQRCodeDialog: false,
      qrcodeRows: [],

      showCreateOneItemQRCodeDialog: false,
      itemQRCodeRows: [],
      UnitBoxNumber: 0,
      sumQty: 0,

      showCreateQRCodePower: false,
      showCreateOneItemQRCodePower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')
    that.bzs = code.getCode(codes, 'PM_ICMOCreateQRCode_BZ')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.qrCode) {
        const qrCodes = that.mainTable.qrCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < qrCodes.length; i++) {
          detail1FilterStr += " OR QRCode LIKE '%" + qrCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.outerQRCode) {
        const outerQRCodes = that.mainTable.outerQRCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < outerQRCodes.length; i++) {
          detail1FilterStr += " OR OuterQRCode LIKE '%" + outerQRCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.CanCreateQRCodeQty <= 0) {
        return { 'background-color': '#cccccc' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 获取条码弹出框表格高度
    getCreateQRCodeHeight: function () {
      return window.innerHeight - 120 + 'px'
    },

    // 创建二维码弹出框表格头部样式
    createQRCodeHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'ThisCreateQty' ||
        column.property === 'ThisUnitPackageNumber' ||
        column.property === 'ThisUnitBoxNumber' ||
        column.property === 'KFDate' ||
        column.property === 'ProducetItemID' ||
        column.property === 'BatchNo')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 创建条码弹出框显示
    showCreateQRCodeDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '1' && that.mainTable.selections[i].Status !== '2') {
          that.$message.error('请选择已下达的生产任务单！')
          return
        }
        // if (that.mainTable.selections[i].CanCreateQRCodeQty <= 0) {
        //   that.$message.error('请选择可生成标签数量大于零的数据！')
        //   return
        // }
      }
      that.qrcodeRows = that.mainTable.selections
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = 0
        qrcodeRow.ThisUnitPackageNumber = qrcodeRow.UnitPackageNumber
        qrcodeRow.ThisUnitBoxNumber = ''
        // qrcodeRow.BatchNo = qrcodeRow.ICMOBatchNoComputeType === '1' ? dateTimeUtil.formartDateTime(new Date(), 'yyyyMMdd') : qrcodeRow.GMPBatchNo
        qrcodeRow.BatchNo = ''
        qrcodeRow.BZ = ''
        qrcodeRow.KFDate = dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      })
      that.showCreateQRCodeDialog = true
    },

    // 生成标签表格生产/采购日期变更方法
    createQRCodeTableKFDateChange: function (row) {
      const that = this
      if (row.KFDate) {
        try {
          row.KFDate = dateTimeUtil.formartDateTime(new Date(row.KFDate), 'yyyy-MM-dd')
          if (row.ICMOBatchNoComputeType === '1') {
            // row.BatchNo = row.KFDate.replace(/-/g, '')
            if (row.BZ && row.BZ.length >= 3) {
              row.BatchNo = row.BZ.substr(0, 2) + row.KFDate.replace(/-/g, '').substr(2) + row.BZ.substr(2, 1) + '00'
            }
          }
          if (row.KFDate.length !== 10) {
            row.KFDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
            if (row.ICMOBatchNoComputeType === '1') {
              // row.BatchNo = ''
            }
          }
          if (row.KFDate && row.KFDate > dateTimeUtil.addDateTime(new Date(), 'DAY', 5, 'yyyy-MM-dd')) {
            row.KFDate = ''
            that.$message.error('生产/采购日期必须在未来5天以内！')
          }
          that.$refs.createQRCodeTable.doLayout()
        } catch {
          that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          row.KFDate = ''
          if (row.ICMOBatchNoComputeType === '1') {
            // row.BatchNo = ''
          }
          that.$refs.createQRCodeTable.doLayout()
        }
      } else {
        that.$refs.createQRCodeTable.doLayout()
      }
    },

    // 自动填充生成数量
    autoCompleteCreateQRCodeQty: function () {
      const that = this
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = qrcodeRow.Qty - qrcodeRow.CreateQRCodeQty
      })
      that.$refs.createQRCodeTable.doLayout()
    },

    // 清除生成数量
    clearCreateQRCodeQty: function () {
      const that = this
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = 0
      })
      that.$refs.createQRCodeTable.doLayout()
    },

    // 生成并打印标签
    createQRCode: async function () {
      const that = this
      let allThisCreateQty = 0
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.qrcodeRows.length; i++) {
        if (that.qrcodeRows[i].ThisCreateQty && !numberReg.test(that.qrcodeRows[i].ThisCreateQty)) {
          that.$message.error('本次生成标签数量必须为不小于0的数字！')
          return
        }
        allThisCreateQty += parseFloat(that.qrcodeRows[i].ThisCreateQty)
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && (!that.qrcodeRows[i].ThisUnitPackageNumber || that.qrcodeRows[i].ThisUnitPackageNumber === '0')) {
          that.$message.error('请输入每包数量！')
          return
        }
        if (that.qrcodeRows[i].ThisUnitPackageNumber &&
          !numberReg.test(that.qrcodeRows[i].ThisUnitPackageNumber)) {
          that.$message.error('每包数量必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && ((!that.qrcodeRows[i].ThisUnitPackageNumber || that.qrcodeRows[i].ThisUnitPackageNumber === '0') ||
          !numberReg.test(that.qrcodeRows[i].ThisUnitBoxNumber))) {
          that.$message.error('每箱最大包数必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && !that.qrcodeRows[i].KFDate) {
          that.$message.error('请输入生产/采购日期！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && !that.qrcodeRows[i].BatchNo) {
          that.$message.error('请输入批号！')
          return
        }
      }
      if (allThisCreateQty <= 0) {
        that.$message.error('至少有一个大于0的本次生成标签数量！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMO.CreateICMOQRCode', {
        rows: that.qrcodeRows
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，生成产品标签成功！')
        that.showCreateQRCodeDialog = false
        const qrcodesObj = JSON.parse(rtnObj.msg.replace(/'/g, '"'))
        const qrcodesAry = []
        for (let i = 0; i < qrcodesObj.qrcodes.length; i++) {
          qrcodesAry.push(qrcodesObj.qrcodes[i].QRCode)
        }
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMQRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMOuterQRCode.rpt', 'OuterQRCode')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 创建条码（单物料）弹出框显示
    showCreateOneItemQRCodeDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length !== 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      if (that.mainTable.selections[0].Status !== '1' && that.mainTable.selections[0].Status !== '2') {
        that.$message.error('请选择已下达的生产任务单！')
        return
      }
      that.itemQRCodeRows = []
      that.itemQRCodeRows.push(Object.assign({}, that.mainTable.selections[0], {
        ThisCreateQty: 0,
        ThisUnitPackageNumber: that.mainTable.selections[0].UnitPackageNumber,
        ThisUnitBoxNumber: '',
        BatchNo: '',
        KFDate: dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      }))
      that.showCreateOneItemQRCodeDialog = true
    },

    // 获取条码弹出框表格高度
    getCreateOneItemQRCodeHeight: function () {
      return window.innerHeight - 170 + 'px'
    },

    // 单物料创建二维码弹出框表格头部样式
    createOneItemQRCodeHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'ThisCreateQty' ||
        column.property === 'ThisUnitPackageNumber' ||
        column.property === 'ThisUnitBoxNumber' ||
        column.property === 'KFDate' || column.property === 'BatchNo' ||
        column.property === 'ProducetItemID')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 生成标签表格生产/采购日期变更方法
    createOneItemQRCodeTableKFDateChange: function (row) {
      const that = this
      if (row.KFDate) {
        try {
          row.KFDate = dateTimeUtil.formartDateTime(new Date(row.KFDate), 'yyyy-MM-dd')
          if (row.ICMOBatchNoComputeType === '1') {
            // row.BatchNo = row.KFDate.replace(/-/g, '')
            if (row.BZ && row.BZ.length >= 3) {
              row.BatchNo = row.BZ.substr(0, 2) + row.KFDate.replace(/-/g, '').substr(2) + row.BZ.substr(2, 1) + '00'
            }
          }
          if (row.KFDate.length !== 10) {
            row.KFDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
            if (row.ICMOBatchNoComputeType === '1') {
              // row.BatchNo = ''
            }
          }
          if (row.KFDate.length !== 10) {
            row.KFDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          }
          that.$refs.createOneItemQRCodeTable.doLayout()
        } catch {
          that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          row.KFDate = ''
          that.$refs.createOneItemQRCodeTable.doLayout()
        }
      }
    },

    // 生成标签表格专用产品号变更方法
    createOneItemQRCodeTableProducetItemIDChange: function (row) {
    },

    // 单物料生成标签添加行方法
    addOneItemQRCodeRow: function () {
      const that = this
      that.itemQRCodeRows.push(Object.assign({}, that.mainTable.selections[0], {
        ThisCreateQty: 0,
        ThisUnitPackageNumber: that.mainTable.selections[0].UnitPackageNumber,
        ThisUnitBoxNumber: '',
        BatchNo: '',
        KFDate: dateTimeUtil.formartDateTime(new Date(), 'yyyy-MM-dd')
      }))
    },

    // 单物料生成标签删除行方法
    deleteOneItemQRCodeRow: function (row, index) {
      const that = this
      that.itemQRCodeRows.splice(index, 1)
      that.sumQtyComputer()
    },

    // 合计数量计算
    sumQtyComputer: function () {
      const that = this
      that.sumQty = 0
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.itemQRCodeRows.length; i++) {
        if (that.itemQRCodeRows[i].ThisCreateQty && !numberReg.test(that.itemQRCodeRows[i].ThisCreateQty)) {
          continue
        }
        that.sumQty += parseFloat(that.itemQRCodeRows[i].ThisCreateQty)
      }
    },

    // 生成并打印标签
    createOneItemQRCode: async function () {
      const that = this
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      if (that.itemQRCodeRows.length <= 0) {
        that.$message.error('请添加行！')
        return
      }
      for (let i = 0; i < that.itemQRCodeRows.length; i++) {
        if (that.itemQRCodeRows[i].ThisCreateQty && !numberReg.test(that.itemQRCodeRows[i].ThisCreateQty)) {
          that.$message.error('本次生成标签数量必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].ThisUnitPackageNumber) {
          that.$message.error('请输入每包数量！')
          return
        }
        if (that.itemQRCodeRows[i].ThisUnitPackageNumber &&
          !numberReg.test(that.itemQRCodeRows[i].ThisUnitPackageNumber)) {
          that.$message.error('每包数量必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].KFDate) {
          that.$message.error('请输入生产/采购日期！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].BatchNo) {
          that.$message.error('请输入批号！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0) {
        } else {
          that.$message.error('本次生成标签数量必须大于0！')
          return
        }
      }
      if (!that.UnitBoxNumber ||
        !numberReg.test(that.UnitBoxNumber)) {
        that.$message.error('每箱最大包数必须为不小于0的数字！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMO.CreateOneItemICMOQRCode', {
        icmo: that.mainTable.selections[0],
        rows: that.itemQRCodeRows,
        unitBoxNumber: that.UnitBoxNumber
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，生成产品标签成功！')
        that.showCreateOneItemQRCodeDialog = false
        const qrcodesObj = JSON.parse(rtnObj.msg.replace(/'/g, '"'))
        const qrcodesAry = []
        for (let i = 0; i < qrcodesObj.qrcodes.length; i++) {
          qrcodesAry.push(qrcodesObj.qrcodes[i].QRCode)
        }
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMQRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=PMOuterQRCode.rpt', 'OuterQRCode')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
